import { formatRawAsISO } from "core-integration/src/utils/datetime";
import { formatInTimeZone } from "date-fns-tz";
import { usePlosTranslations } from "../../../../contexts/PlosTranslationsContext";
import { fixtureKOTime } from "./fixtureTime.css";
import { IFixtureTime } from "./types";

const FixtureTime = ({ fixture }: IFixtureTime) => {
  const { toBeConfirmedAbbreviation } = usePlosTranslations();
  const dateFormat = "HH:mm";
  if (fixture.provisional_start_time) {
    return <time className={fixtureKOTime}>{toBeConfirmedAbbreviation}</time>;
  }

  if (fixture.kickoff_time && fixture.kickoffDate) {
    return (
      <time
        className={fixtureKOTime}
        dateTime={formatRawAsISO(fixture.kickoff_time)}
      >
        {formatInTimeZone(
          fixture.kickoffDate,
          Intl.DateTimeFormat().resolvedOptions().timeZone,
          dateFormat,
        )}
      </time>
    );
  }

  return <time className={fixtureKOTime}>-</time>;
};

export default FixtureTime;
